import { concat, of, } from 'rxjs';
import { actions as bootstrapActions, } from '@ezugi/bootstrap';

import { gameResultsSelector, } from '../../selectors/game';
import payoutsActions from '../../actions/payouts';

const {
  gameActions: { game, },
  uiActions: { progressBar, },
  betActions: { history, },
} = bootstrapActions;

export default function handlePlaceYourBets(socketMessage, state) {
  const {
    payouts,
  } = socketMessage;

  return concat(of(
    payoutsActions.payouts.set({ payouts, }),
    game.set({
      gameResults: { ...gameResultsSelector(state), wonSidebets: [], },
    }),
    history.reset(),
    progressBar.reset(),
  ));
}
